

import { Navigate } from 'react-router-dom';
import { getSecureUser } from './utils/secureStorage';


function Private({children}){
    const user = getSecureUser();
    if(user===null){
    return <Navigate to="/login" />;
    }
    else{
        return children;
    }
}

export default Private;